export const AppSections = {
    LOBBY_TEXAS_CASH: 'lobby_poker_texas_cash',
    LOBBY_AOF_FIAT: 'lobby_poker_aof',
    LOBBY_AOF_CRYPTO: 'lobby_poker_crypto',
    LOBBY_TEXAS_TOURNAMENTS: 'lobby_poker_texas_tournaments',
    POKER_SINGLE_ROOM_VIEW: 'poker_single_room_view',
    POKER_GRID_ROOM_VIEW: 'poker_grid_room_view',
    CASINO_GAME_VIEW: 'casino_game_view',
    CASINO: 'casino',
    BETTING: 'betting',
    GAMES: 'games',
    SPINS: 'spins',
    ERROR: 'error',
    LOGIN: 'login',
    WIN_INFO_DEBUG: 'win_info_debug',
    PLAYER_SLOT_DEBUG: 'player_slot_debug',
    LOBBY_TOURNAMENT: 'lobby_tournament',
    LOBBY_TOURNAMENT_ROOMS: 'lobby_tournament_rooms',
    LOBBY_TOURNAMENT_RANKINGS: 'lobby_tournament_rankings',
    LOBBY_HOME: 'lobby_home',
} as const;
